import React, { useState } from "react";
import Card from "../Card";
import { Toolbar } from "../../ui-components";
import ForAssignTable from "./ForAssignTable";
import AssignTable from "./AssignTable";
import DiscardedTable from "./DiscardedTable";
import CreateLeadForm from "./CreateLeadForm";
import UpdateLeadForm from "../../generalComponents/UpdateLeadForm";
import Filters from "../../generalComponents/Filters";


const Conecta = ({user, userName}) => {
  const [option, setOption] = useState(1);
  const [assingLead, setAssignLead] = useState();
  const [order, setOrder] = useState("1")
  const [canal, setCanal] = useState("0")
  const [asesor, setAsesor] = useState("0")

  
  const toggleTab = (index) => {
    setOption(index);
  };
  const overridesToolbar = {
    ButtonLeft: {
      backgroundColor: option === 4 && "#323977",
      onClick: () => toggleTab(4),
    },
    ButtonUno: {
      backgroundColor: option === 1 && "#323977",
      onClick: () => toggleTab(1),
    },
    ButtonDos: {
      backgroundColor: option === 2 && "#323977",
      onClick: () => toggleTab(2),
    },
    ButtonTres: {
      backgroundColor: option === 3 && "#323977",
      onClick: () => toggleTab(3),
    },
    Divider46215981: {display: "none"},
    ButtonCinco: {display: "none"},
  };


  return (
    <div className="mt-16">
     {option < 4 ? 
      (<Card
        textTitle="Leads"
        elementBody={
          <div className="flex flex-col gap-6 px-6">
            <div className="flex justify-center">
              <Toolbar type={"lead"} width={"100%"} overrides={overridesToolbar}/>
            </div>
            <div>
              <Filters setorder={setOrder} order={order} canal={canal} setCanal={setCanal} asesor={asesor} setAsesor={setAsesor} user={user}/>
            </div>
            {option === 1 && (<div><ForAssignTable setAssignLead={setAssignLead} onToggleTab={toggleTab} order={order} canal={canal} asesor={asesor}/> </div>)}
            {option === 2 && (<div><AssignTable order={order} setorder={setOrder} canal={canal} asesor={asesor}/> </div>)}
            {option === 3 && (<div><DiscardedTable order={order} canal={canal} asesor={asesor}/></div>)}
          </div>
        }
      />) : option === 4 ?
        <CreateLeadForm onToggleTab={toggleTab} user={user} userName={userName}/> 
        : <UpdateLeadForm assingLead={assingLead} onToggleTab={toggleTab} user={user} userName={userName}/>
      } 
    </div>
  );
};

export default Conecta;
